export default __webpack_public_path__ + "assets/mp3/2fd664e6d31a3c87b9a7a478aad5ffd9.mp3";